import { Component, OnInit } from '@angular/core';

interface SupportContent {
  title: string;
  sub_title: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  supportContent: SupportContent[] = [
    {
      title: 'JOEL P. LONGARES',
      sub_title: 'CEO/PRESIDENT',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores eum dolore magni quisquam odio! Cum nulla, impedit dicta deserunt dignissimos, quidem sunt sus',
      image: '/assets/img/dummy-image/600x650.png',
    },
    {
      title: 'LOGO DELIVERS FOR FREE',
      sub_title: 'Abandoned Boxes',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores eum dolore magni quisquam odio! Cum nulla, impedit dicta deserunt dignissimos, quidem sunt sus',
      image: '/assets/img/dummy-image/600x650.png',
    },
    {
      title: 'PROHIBITTED ITEMS',
      sub_title: '',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores eum dolore magni quisquam odio! Cum nulla, impedit dicta deserunt dignissimos, quidem sunt sus',
      image: '/assets/img/dummy-image/600x650.png',
    },
    {
      title: 'BALIKBAYAN BOX REQUIREMENTS',
      sub_title: 'Important Advisory',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores eum dolore magni quisquam odio! Cum nulla, impedit dicta deserunt dignissimos, quidem sunt sus',
      image: '/assets/img/dummy-image/600x650.png',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
